/* eslint-disable react-hooks/exhaustive-deps */
// importer la librairie de react
import { useEffect, useState } from "react"
import { Typography } from "@mui/material"
import { PageConfig, CwComponentConfig } from "../../models/pageConfig"
import Utils from "../../utils/stringUtils"
import DialogService from "../../services/dialog"
import UIService from "../../services/UIService"
import { DialogType } from "../../models/dialog"
import DynamicParamsService from "../../services/dynamicParams"
import CwIcon from "./cw-icon"
import ActionService from "../../services/action"

const CwText = (
    props: PageConfig<CwComponentConfig.Text>
): React.JSX.Element => {
    const { config } = props
    // création de toute les variables à partir des config
    const {
        text,
        variant,
        textIcon,
        subTitle,
        subTitle2,
        subTitleVariant,
        subTitleIcon,
        useRefreshListener,
        pipe,
        context,
        fontFamily,
    } = config

    const color = UIService.getColorByName(config.color)
    const subTitleColor = subTitle
        ? UIService.getColorByName(config.subTitleColor)
        : undefined
    const className = config.className ? config.className : ""
    const fontWeight = config.fontWeight ? config.fontWeight : "normal"
    const subTitleClassName = config.subTitleClassName
        ? config.subTitleClassName
        : ""
    const noSubPipe = config.noSubPipe || false

    const [textState, setTextState] = useState({
        title: "",
        subTitleText: "",
        subTitleText2: "",
    })
    const [textClassName, setTextClassName] = useState<string>(
        config.textClassName || ""
    )
    const rightIcon = config.rightIcon || false

    const init = () => {
        DynamicParamsService.resolve([text, subTitle, subTitle2], context).then(
            (result) => {
                if (result) {
                    setTextState({
                        title: result[0] as string,
                        subTitleText: result[1] as string,
                        subTitleText2: result[2] as string,
                    })
                }
            },
            (err) => {
                console.error(err)
            }
        )
        // exec les actions d'init
        if (props.actions && props.actions.length)
            ActionService.exec(props.actions, context).then((conf) => {
                // override des attrs de state par ceux de conf
                if (conf?.type === "config") {
                    if (conf.value.textClassName)
                        setTextClassName(conf.value.textClassName)
                }
            })
    }

    // useEffect des maj du texte
    useEffect(() => {
        init()
    }, [config])

    useEffect(() => {
        let subId: string | null = null
        // on s'abonne aux changements de route
        if (useRefreshListener)
            subId = DialogService.getInstance().subscribe(
                "pageRefesh",
                DialogType.REFRESH,
                props.name,
                () => {
                    init()
                }
            )

        // unsubscribe
        return () => {
            if (subId) DialogService.getInstance().unsubscribe(subId)
        }
    }, [])
    return (
        <div
            data-testid="mainContainer"
            className={`textColWrapper ${className}`}
        >
            <div
                data-testid="textContainer"
                className={`flexBox ${textClassName}`}
            >
                {textIcon && !rightIcon ? (
                    <CwIcon
                        name="textIcon"
                        type="icon"
                        config={{ ...textIcon, context }}
                        actions={textIcon.actions}
                    />
                ) : null}
                <Typography
                    className={textIcon ? "ml-1" : ""}
                    style={{
                        color: config.color ? color : undefined,
                        fontWeight,
                        fontFamily,
                    }}
                    variant={variant}
                >
                    {Utils.specialTypeRender(
                        pipe,
                        textState.title,
                        undefined,
                        context
                    )}
                </Typography>
                {textIcon && rightIcon ? (
                    <CwIcon
                        name="textIcon"
                        type="icon"
                        config={{ ...textIcon, context }}
                        actions={textIcon.actions}
                    />
                ) : null}
            </div>
            {subTitle ? (
                <div
                    data-testid="subTextContainer"
                    className={`flexBox ${subTitleClassName}`}
                >
                    {subTitleIcon ? (
                        <CwIcon
                            name="subTitleIcon"
                            type="icon"
                            config={subTitleIcon}
                        />
                    ) : null}
                    <Typography
                        style={{ color: subTitleColor }}
                        variant={subTitleVariant}
                    >
                        {noSubPipe
                            ? textState.subTitleText
                            : Utils.specialTypeRender(
                                  pipe,
                                  textState.subTitleText,
                                  undefined,
                                  context
                              )}
                        {subTitle2 ? (
                            <span>
                                {" "}
                                -{" "}
                                {Utils.specialTypeRender(
                                    pipe,
                                    textState.subTitleText2,
                                    undefined,
                                    context
                                )}
                            </span>
                        ) : null}
                    </Typography>
                </div>
            ) : null}
        </div>
    )
}
export default CwText
